(() => {
  if (window.__herDadCompactCardsLoaded) return;
  window.__herDadCompactCardsLoaded = true;

  let gesture = null;
  let suppressedClick = null;

  function activateColor(card, button, manual = true) {
    if (!card || !button) return;
    if (manual) card.dataset.hdColorChosen = 'true';

    const image = card.querySelector('[data-hd-card-image]');
    const imageUrl = button.dataset.image;
    if (image && imageUrl) {
      image.removeAttribute('srcset');
      image.src = imageUrl;
    }

    const productUrl = button.dataset.productUrl;
    if (productUrl) {
      card.querySelectorAll('[data-hd-product-link]').forEach((link) => {
        link.href = productUrl;
      });
    }

    card.querySelectorAll('[data-hd-color]').forEach((swatch) => {
      swatch.setAttribute('aria-pressed', swatch === button ? 'true' : 'false');
    });
  }

  const targetElement = event => event.target instanceof Element ? event.target : null;
  const colorOptions = card => [...card.querySelectorAll('[data-hd-color]')].filter(button => button.dataset.image);
  const reset = () => { gesture = null; suppressedClick = null; };

  function suggestCartColor(card) {
    if (card.dataset.hdColorChosen || gesture?.card === card) return;
    const color = document.documentElement.dataset.hdBrowseCartColor;
    if (color === undefined) return; // Initial cards already use the server cart.
    const swatch = colorOptions(card).find(button => button.dataset.hdColor === color && button.dataset.hdColorAvailable === 'true');
    if (color && swatch) {
      activateColor(card, swatch, false);
      return;
    }
    const image = card.querySelector('[data-hd-card-image]');
    if (image && card.dataset.hdDefaultImage) {
      image.removeAttribute('srcset');
      if (image.getAttribute('src') !== card.dataset.hdDefaultImage) image.src = card.dataset.hdDefaultImage;
    }
    if (card.dataset.hdDefaultUrl) card.querySelectorAll('[data-hd-product-link]').forEach(link => { link.href = card.dataset.hdDefaultUrl; });
    card.querySelectorAll('[data-hd-color]').forEach(button => {
      button.setAttribute('aria-pressed', button.dataset.hdColor === card.dataset.hdDefaultColor ? 'true' : 'false');
    });
  }

  const suggestAll = () => document.querySelectorAll('[data-hd-card]').forEach(suggestCartColor);
  document.addEventListener('herdad:cart-color', suggestAll);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches('[data-hd-card]')) suggestCartColor(node);
      node.querySelectorAll('[data-hd-card]').forEach(suggestCartColor);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  suggestAll();

  document.addEventListener('click', event => {
    const target = targetElement(event);
    if (!target) return;
    const swatch = target.closest('[data-hd-color]');
    if (swatch) {
      event.preventDefault();
      suppressedClick = null;
      activateColor(swatch.closest('[data-hd-card]'), swatch);
      return;
    }
    if (event.detail === 0 || !suppressedClick) return;
    const { media, until } = suppressedClick;
    if (performance.now() >= until) {
      suppressedClick = null;
      return;
    }
    if (media.contains(target)) {
      suppressedClick = null;
      event.preventDefault();
    }
  }, true);

  window.addEventListener('pointerdown', () => { suppressedClick = null; }, { capture: true, passive: true });
  document.addEventListener('touchstart', event => {
    reset();
    if (event.defaultPrevented || event.touches.length !== 1) return;
    const media = targetElement(event)?.closest('.hd-card__media');
    const card = media?.closest('[data-hd-card]');
    if (!card || colorOptions(card).length < 2) return;
    const touch = event.touches[0];
    gesture = { media, card, id: touch.identifier, x: touch.clientX, y: touch.clientY, axis: null };
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', event => {
    if (!gesture) return;
    if (event.defaultPrevented || event.touches.length !== 1) { gesture = null; return; }
    const touch = [...event.touches].find(item => item.identifier === gesture.id);
    if (!touch) { gesture = null; return; }
    const dx = Math.abs(touch.clientX - gesture.x);
    const dy = Math.abs(touch.clientY - gesture.y);
    if (!gesture.axis && Math.max(dx, dy) >= 10) {
      gesture.axis = dx > dy * 1.25 ? 'x' : 'y';
      if (gesture.axis === 'y') { gesture = null; return; }
    }
    if (gesture.axis === 'x' && dx >= 35 && dx > dy * 1.25 && event.cancelable) event.preventDefault();
  }, { passive: false });

  document.addEventListener('touchend', event => {
    const current = gesture;
    gesture = null;
    if (!current || event.defaultPrevented || event.touches.length || !current.media.isConnected) return;
    const touch = [...event.changedTouches].find(item => item.identifier === current.id);
    if (!touch) return;
    const dx = touch.clientX - current.x;
    const dy = touch.clientY - current.y;
    if (Math.abs(dx) < 35 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
    const swatches = colorOptions(current.card);
    if (swatches.length < 2) return;
    const index = Math.max(0, swatches.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    const next = (index + (dx < 0 ? 1 : -1) + swatches.length) % swatches.length;
    if (event.cancelable) event.preventDefault();
    suppressedClick = { media: current.media, until: performance.now() + 700 };
    activateColor(current.card, swatches[next]);
  }, { passive: false });

  document.addEventListener('touchcancel', reset, { passive: true });
  window.addEventListener('pagehide', reset);
  window.addEventListener('pageshow', reset);
})();
